import React from "react";
import type { ModeRendererProps } from "./types";

export function VasarelyGazelleMode({ Copy }: ModeRendererProps) {
  return (
    <g>
      <rect width={794} height={1123} fill="#e8f6e8" />
      {Array.from({ length: 6 }).map((_, i) => (
        <path key={i} d={`M${80+i*120} 300 q40 -120 80 0`} stroke="#6a8f6a" strokeWidth={12} fill="none" opacity={0.6} />
      ))}
      <g className="mode-copy" transform="translate(48,840)" fill="#356b35"><text x={0} y={0} fontSize={18}>{Copy?.title}</text></g>
    </g>
  );
}

export default VasarelyGazelleMode;
